import { CONTENT_TYPE, type ContentType } from 'src/data/contentType';

import { BRIEF_TYPE, type BriefType } from './const';

export const contentTypeFromBriefType = (briefType: BriefType): ContentType =>
  [BRIEF_TYPE.unifiedProduct, BRIEF_TYPE.unifiedPromotionalEmail].includes(briefType)
    ? CONTENT_TYPE.product
    : CONTENT_TYPE.content;

export const brandBriefsAvailableForBriefType = (briefType: BriefType): boolean =>
  contentTypeFromBriefType(briefType) === CONTENT_TYPE.product;

export const isExtractingBriefType = (briefType: BriefType): boolean =>
  [
    BRIEF_TYPE.unifiedContent,
    BRIEF_TYPE.unifiedProduct,
    BRIEF_TYPE.unifiedPromotionalEmail,
  ].includes(briefType);

export const isManualBriefType = (briefType: BriefType): boolean =>
  [
    BRIEF_TYPE.unifiedProduct,
    BRIEF_TYPE.unifiedContent,
    BRIEF_TYPE.socialManual,
    BRIEF_TYPE.unifiedPromotionalEmail,
    BRIEF_TYPE.email,
  ].includes(briefType);
